import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { noFilterCountersQueryKey } from '@autobid/ui/composables/car/data/useNoFilterCounters'
import { NO_FILTER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useNoFilterCountersSocket'
import { useQueryClient } from '@tanstack/vue-query'

export function useNoFilterItemDelete() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const itemDelete = () => {
    startListen({
      eventName: 'premium.ITEM_DELETED',
      callbackName: NO_FILTER_SOCKET_CALLBACK,
      callback: (event) => {
        const queryKey = noFilterCountersQueryKey.byAuctionId(event.context.auctionId)
        queryClient.invalidateQueries(queryKey)
      },
    })
  }

  return { itemDelete }
}
